<template>
    <div class='container' ref="containerBox" @scroll="handleScroll">
        <div ref="stickyBox" :class="[{ sticky: isSticky }, { box: !isSticky }]"
            :style="{ background: isSticky ? '#fff' : 'transparent' }">
            <titlePage :isSticky="isSticky" :scrollToTop="scrollToTop"></titlePage>
        </div>
      
        <div class='contentBox'>
            <div class="content">
                  <notice-page></notice-page>
                <div style="background:#fff;padding:20px;border-radius: 10px;margin-top: 20px;">
                    <el-input placeholder="请输入内容" v-model="searchForm.keyword" class="input-with-select"
                        style="width: 70%;border:2px solid #0092FF;border-radius: 4px;">
                        <template slot="prepend">
                            <div class="cursor" @click="dialogVisible = true">{{ select || '全国' }}<i
                                    class="el-icon-caret-bottom"></i></div>
                        </template>
                        <el-button slot="append" icon="el-icon-search" type="primary"
                            style="background: #0092FF;color: #fff;" @click="search">搜索</el-button>
                    </el-input>
                    <div class="topcontent">
                        <!-- <p>城市和区域</p> -->
                        <div class="flex" style="display: none;">
                            <div class="tags cursor" @click="changeHotCity()"
                                :style="{ color: '全国' == select ? '#0092FF' : '' }">全国
                            </div>
                            <div v-for="(item, index) in hotCityList" :key="index" class="tags cursor"
                                @click="changeHotCity(item)" :style="{ color: item.title == select ? '#0092FF' : '' }">
                                {{
                                    item.title || ''
                                }}
                            </div>
                        </div>
                        <div class="" style="margin-top: 20px;">
                            <el-select v-model="searchForm.cate_id" placeholder="职位类型" @change="search">
                                <el-option v-for="item in jobTypeList" :key="item.cate_id" :label="item.cate_name"
                                    :value="item.cate_id">
                                </el-option>
                            </el-select>
                            <el-select v-model="searchForm.status" placeholder="交付方式" style="margin-left: 20px;"
                                @change="search">
                                <el-option v-for="item in payTypeList" :key="item.value" :label="item.title"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="topcontent" style="margin-top: 0;">
                    <div class="flex" style="padding:  20px 0 10px 20px;">
                        <!-- <div style="margin:-20px  20px 0 0;">排序</div> -->
                        <el-tabs v-model="searchForm.order" @tab-click="handleClick">
                            <el-tab-pane label="默认" name="time"></el-tab-pane>
                            <el-tab-pane label="奖金高" name="fee"></el-tab-pane>
                            <el-tab-pane label="招聘人数多" name="people"></el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
                <div class="list-box" style="">
                    <div class="list-item cursor boxShadow" style="display: flex; flex-direction: column;padding: 0;"
                        v-for="(item, index) in list" :key="index" @click="getDetailes(item)">
                        <div class="card">
                            <div class="flex-between">
                                <div class="title">{{ item.title || '' }}</div>
                                <el-button type="primary" size="mini" @click.stop="getOrder(item)">接单</el-button>
                            </div>
                            <div class="flex" style="margin-top: 2px;">
                                <div class="tag">{{ item.city_name || '' }}</div>
                                <div class="tag">招{{ item.people || 0 }}人</div>
                            </div>
                            <div style="margin-top: 10px;" class="PriceText"> {{ item.pay || '' }} </div>
                            <div style="margin-top: 10px;" class="flex-between">
                                <div class="text"> {{ item.company || '' }}</div>
                                <div class="text" style="color: #999;">{{ item.create_time || '' }}</div>
                            </div>
                        </div>
                        <div class="GradientBackground flex-between" style="border-radius: 0 0 10px 10px;">
                            <div>{{ item.pay_list || '' }}</div>
                            <div class="price">固定金额 {{ item.pay_fee || 0 }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <fotterVue></fotterVue>
        <el-dialog title="城市" :visible.sync="dialogVisible" width="800px" :before-close="handleClose">
            <cityPage @changeCity="changeCity" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import titlePage from '@/components/titlePage.vue';
import fotterVue from '@/components/fotter.vue';
import cityPage from '@/components/cityPage.vue';
import noticePage from '@/components/noticePage3.vue'
export default {
    name: '',
    components: {
        titlePage,
        fotterVue,
        cityPage,
        noticePage
    },
    data() {
        return {
            cityList: [
                {
                    name: "全国",
                    id: ''
                }, {
                    name: "北京",
                    id: ''
                },
                {
                    name: "上海",
                    id: ''
                }, {
                    name: "广州",
                    id: ''
                }, {
                    name: "深圳",
                    id: ''
                }, {
                    name: "西安",
                    id: ''
                }, {
                    name: "长沙",
                    id: ''
                }, {
                    name: "厦门",
                    id: ''
                }, {
                    name: "重庆",
                    id: ''
                }, {
                    name: "西安",
                    id: ''
                }, {
                    name: "其他城市",
                    id: ''
                }
            ],
            jobTypeList: [
                {
                    cate_id: 0,
                    cate_name: "全部行业"
                }
            ],
            payTypeList: [{
                value: 0,
                title: "全部类型"
            }, {
                value: 1,
                title: "邀约"
            },
            {
                value: 2,
                title: "面试"
            },
            {
                value: 3,
                title: "offer"
            },
            {
                value: 4,
                title: "入职"
            },
            {
                value: 5,
                title: "保期"
            },
            ],
            value: '',
            searchForm: {
                status: 0,
                cate_id: 0,
                keyword: "",
                order: 'time',
                page: 1,
                size: 10,
            },
            list: [],
            select: "1",
            isSticky: false,
            stickyBoxTop: 0,
            hotCityList: [],
            dialogVisible: false,
            isStatus: true,
        };
    },
    computed: {},
    watch: {},
    methods: {
        handleScroll(event) {
            const scrollTop = event.target.scrollTop
            this.isSticky = scrollTop > this.stickyBoxTop;
            const bottomOfWindow = this.$refs.containerBox.scrollHeight - this.$refs.containerBox.scrollTop - this.$refs.containerBox.clientHeight
            // console.log(bottomOfWindow);
            if (this.isStatus == true && bottomOfWindow <= 50) {
                this.searchForm.page += 1
                this.isStatus = false
                this.getList()
            }
        },
        scrollToTop() {
            this.$refs.containerBox.scrollTop = 0;
        },
        handleClick(tab, event) {
            console.log(tab, event);
            this.searchForm.page = 1
            this.getList()
        },
        getDetailes(item) {
            this.$router.push({
                path: '/RecruitmentDetails', query: {
                    id: item.id
                }
            });
        },
        getList() {
            if (this.searchForm.page == 1) {
                this.list = []
            }
            this.$api.index.getIndexList(this.searchForm).then(res => {
                console.log(res, '666');
                this.loading = false
                if (res.code == 200) {
                    this.list = [...this.list, ...res.data.list]
                    this.isStatus = res.data.total > this.list.length ? true : false
                }
            })
        },


        getjobType() {
            this.$api.index.getjobType().then(res => {
                this.loading = false
                if (res.code == 200) {
                    this.jobTypeList = [...this.jobTypeList, ...res.data]
                    this.searchForm.cate_id = Number(this.$route.query.cate_id) || 0
                    this.searchForm.page == 1
                    this.getList()
                }
            })

        },
        getOrder(item) {
            console.log(item);
            this.$api.index.getOrder({ id: item.id }).then(res => {
                this.loading = false
                if (res.code == 200) {
                    this.$message.success('接单成功')
                }
            })
        },
        getCityIndex() {
            this.$api.index.CityIndex().then(res => {
                if (res.code == 200) {
                    this.hotCityList = res.data.hot
                }
            })
        },
        changeHotCity(item) {
            if (!item) {
                item = { id: 0, title: "全国" }
            }
            console.log(item, 'iii');
            this.changeCity(item)
            this.$router.go(0)
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },
        changeCity(item) {
            localStorage.setItem('cityId', item.id)
            localStorage.setItem('cityName', item.title)
        },
        submit() {
            this.select = localStorage.getItem('cityName')
            this.dialogVisible = false
            // this.getDate()
            this.$router.go(0)
        },
        search() {
            this.searchForm.page == 1
            this.getList()
        }
    },
    created() {

    },
    mounted() {
        this.select = localStorage.getItem('cityName')
        this.scrollToTop()
        this.getjobType()
        this.getCityIndex()
    },
    beforeCreate() { },
    beforeMount() { },
    beforeUpdate() { },
    updated() { },
    beforeDestroy() { },
    destroyed() { },
    activated() { },
}
</script>
<style lang='scss' scoped>
.contentBox {
    background: linear-gradient(0deg, #F6F8FE 0%, #F6F8FE 78%, #CEEAFF 100%);
    margin-top: 60px;
    min-height: 55vh;
}

.content {
    padding: 30px 0;
}

.serchBox {
    width: 70%;
    border: 2px solid #0092FF;
    border-radius: 6px;
}

.topcontent {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    margin-top: 30px;

    .tags {
        margin: 0 20px;
    }

    ::v-deep input {
        background: rgb(245, 246, 250) !important;
        color: #000;
    }

    ::v-deep .el-tabs__nav-wrap::after {
        background-color: transparent !important;
    }

    ::v-deep .el-input__inner {
        border-color: rgb(245, 246, 250) !important;
    }

    ::v-deep .el-select .el-input .el-select__caret {
        color: #333 !important;
    }
}

::v-deep .el-select .el-input {
    width: 120px;
}

.list-item {
    max-width: calc((100% - 48px) / 3)
}

::v-deep .el-input-group__prepend {
    background-color: transparent !important;
}


::v-deep .el-input-group__append {
    // background: rgb(42, 163, 254) !important; 
    position: relative;
    width: 90px;

    .el-button {
        position: absolute;
        // top: 10px;
        // margin-top: -10px;

        top: 7px;
        right: 19px;
        height: 44px;
        width: 91px;
    }
}

::v-deep .el-dialog__body {
    padding: 0px 20px !important;
}
</style>